import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import { trackEventLog } from '../../../core/utils'
import { COURSE_DETAIL } from '../../../config'
import Link from '../../common/Link'
import BlurImg from '../../common/BlurImg'
import CourseCard from '../../common/CourseCard'
import hitsDefault from '../../common/static/hitsDefault.png'

class Section extends React.Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
  }

  render() {
    const { data } = this.props
    /**
     * 因为后台偷懒不做限制
     * 所以只能前台这么傻的限制了 by zhulin
     */
    let sliceInx = 8
    if (data.head_img) {
      if (data.courses.length > 2 && data.courses.length < 6) {
        sliceInx = 2
      } else if (data.courses.length > 6 && data.courses.length < 8) {
        sliceInx = 6
      }
    } else if (data.courses.length > 4 && data.courses.length < 8) {
      sliceInx = 4
    }

    return (
      <div className={s.root}>
        <h2 className={s.title}>{data.tag.name}</h2>
        <Link
          className={s.more}
          onClick={() => { trackEventLog(`w/index/course/more/${data.tag.id}`) }}
          to={`/tag/${data.tag.id}`}
        >更多课程</Link>
        <div>
          {data.head_img ?
            <Link
              onClick={() => { trackEventLog(`w/index/course/1/${data.tagId}`) }}
              className={s.headImgWrap}
              extraParams={{ inLoc: `fp_speCos_1_1_tag${data.tag.id}` }}
              to={`${COURSE_DETAIL}${data.head_courseId}`}
            >
              <BlurImg
                placeHolder={hitsDefault}
                addStyle={s.headImg}
                originSrc={data.head_img}
              />
            </Link> : null}
          {
            data.courses.slice(0, sliceInx).map((course, inx) => (
              <CourseCard
                inLoc={`fp_speCos_2_${inx}_tag${data.tag.id}`}
                hasBannerLayout={!!data.head_img}
                onClick={() => { trackEventLog(`w/index/course/2/${data.tagId}`) }}
                key={`home-sec-course-${course.id}`}
                data={course}
              />))
          }
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Section);



// WEBPACK FOOTER //
// ./src/components/p_home/Section/index.js